/* Start of Backend API Types */

// use autogenerated api
export type {
  EocStudyPlanSectionType,
  StudyPlanScope,
  EocClientStudyPlan,
  EocClientDraftSection,
  EocClientDraftStudyPlan,
  EocClientDraftItem,
  EocStudyPlanActivationInheritMode,
  EocClientDraftMeta,
  Program,
  EntityPlanInfo,
  RefScope,
  AvailableContentItem,
  NewPlanIntent,
  newPlanInputFormProperties
} from "../../../types/gqlTypes/graphql"

export enum PlanIntent {
  FROM_MY = "FROM_MY",
  FROM_RECOMMENDED = "FROM_RECOMMENDED",
  NEW = "NEW"
}

export type StudyPlanSubType = "ADAPTIVE" | "MANUAL"

/* End of Backend API Types */

export interface StudyPlanLesson {
  id: string
  title: string
  complete?: number
  correct?: number
  items: string[]
}

export interface StudyPlanSection {
  id: string
  name: string
  seconds: number
  complete?: number
  correct?: number
  lessons: StudyPlanLesson[]
}

export enum ExistingPlanOptions {
  NOTSET = "not_set",
  NO_OVERRIDE = "no_override",
  OVERRIDE = "override"
}

/* Seconds to hours would be = 0 | 5 | 10 | 15 | 20 | 25 | 30 */
export type Seconds = 0 | 18000 | 36000 | 54000 | 72000 | 90000 | 108000

export interface SimplePlan {
  id: string
  name: string
  seconds: Seconds
}

export interface StudyPlanView {
  [key: string]: {
    seq: number
    plans: {
      district?: SimplePlan | {}
      school?: SimplePlan[] | []
    }
  }
}

export interface StudyPlanSubject {
  name: string
  iconPath: string
  category: "math" | "english" | "biology" | "ushistory" | "overall"
}

export type SnackbarError = {
  variant?: any
  message: string
  error?: boolean
  withUndo?: boolean
  undoEvent?: any
}

export type ProgramNameGetterType = {
  get: (options?: {
    includeArticle?: boolean
    capitalizeArticle?: boolean
    dependsOnProduct?: boolean
  }) => string
  documentHead: string
  isCCMRProduct: boolean
}
